<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13hxLw7/tc-custom/9781488029332.jpg?1726519075439" alt="This image is the cover for the book Smooth-Talking Cowboy, The Gold Valley Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Smooth-Talking Cowboy, The Gold Valley Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>In this romance series launch—Welcome Gold Valley, Oregon, where a rough-and-tumble rancher and the girl next door learn that opposites attract.</b><br/><br/>Olivia Logan has a plan: win back her ex by making him see what he’s missing. But first she needs to find a man who’s willing to play along. With his laid-back cowboy charm and knack for getting under her skin, Luke Hollister is an unlikely hero—but he wants her help convincing her father to sell him land, which means he needs her as much as she needs him.<br/><br/>Luke likes his life—and his women—uncomplicated. So why does good girl Olivia heat his blood like no one else? She’s always been off-limits, but the more time they spend as Gold Valley’s hottest new “couple,” the more real it’s starting to feel. Luke was supposed to help her win back another man . . . not keep her in his arms. But now that he has her there, he’s not sure he’ll ever let go.<br/><br/><b>Be sure to check out the rest of the Gold Valley series.</b><br/><br/><b>Praise for <i>Smooth-Talking Cowboy</i></b><br/><br/>“Ms. Yates has a gift for layering characters impeccably and her skill is put to good use here. . . . If you’re a fan of the opposites attract trope, small town romances, or cowboys in general, I think <i>Smooth-Talking Cowboy</i> is worth your time.” —All About Romance<br/><br/>“Really good sexual tension.” —Smexy Books
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maisey Yates
      </h2>
      
      <p class="authorDescription body article">Maisey Yates is a New York Times bestselling author of over one hundred romance novels. Whether she&#39;s writing strong, hard working cowboys, dissolute princes or multigenerational family stories, she loves getting lost in fictional worlds. An avid knitter with a dangerous yarn addiction and an aversion to housework, Maisey lives with her husband and three kids in rural Oregon. Check out her website, maiseyyates.com or find her on Facebook.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00029c67